export const CLOTHING_SIZES = [
  "0-3 months", "3-6 months", "6-9 months", "12 months", "18 months/1T",
  "24 months/2T", "3T", "4T",
  "4 - youth", "5 - youth", "6 - youth", "7 - youth", "8 - youth",
  "10 - youth", "12 - youth", "14 - youth", "16 - youth",
  "XS - youth", "S - youth", "M - youth", "L - youth", "XL - youth",
  "S - adult", "M - adult", "L - adult", "XL - adult",
];
